import script from "./CustomTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&setup=true&lang=js"

import "./CustomTextarea.vue?vue&type=style&index=0&id=009b4566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-009b4566"]])

export default __exports__